import { Form, FormInfo } from "components/Forms";
import { RichText } from "components/RichTextWidget";
import { useTranslation } from "features/translations";
import { buildWidgetInstanceId } from "features/widgets";
import { WIDGETS_REGISTRY } from "features/widgets/widgets.config";
import {
  Action,
  Container,
  DetailsBlock,
  Heading4,
  Icon,
  ImageLite,
  ModalWrapper,
  PageLink,
  Paragraph,
} from "shared/components";
import { useCollectedData } from "shared/contexts/PageData";
import { useToggle } from "shared/hooks";

import styles from "./LayoutWidget035.module.scss";

export const LayoutWidget035 = ({ payload }) => {
  const { t } = useTranslation();
  const instanceId = buildWidgetInstanceId(
    "l035",
    payload.id,
    WIDGETS_REGISTRY["LAYOUT-WIDGET"]
  );
  const { courses } = useCollectedData(instanceId, [
    { name: "courses", defaultValue: [] },
  ]);

  const { opened, onOpen, onClose } = useToggle();

  const course = courses?.[0] ?? {};

  const requestType = course?.button?.type ?? "form";
  const form = course.button?.form ?? {};
  const buttonText = course.button?.buttonText ?? "";
  const link = course.button?.link ?? "";

  if (courses.length === 0) {
    return null;
  }

  const items = [
    { id: "date", label: t("date"), text: course.courseStartDate },
    { id: "time", label: t("time"), text: course.courseDuration },
    { id: "price", label: t("price"), text: course.coursePrice },
    { id: "place", label: t("place"), text: course.courseFormat },
  ];

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.top}>
          <div className={styles.block}>
            <Heading4 className={styles.headline} color="dark">
              {course.title}
            </Heading4>
            <RichText
              value={course.description}
              className={styles.description}
            />
          </div>
          <div className={styles.block}>
            <DetailsBlock items={items} className={styles.course} />
            <div className={styles["button-wrap"]}>
              {requestType === "form" ? (
                <Action onClick={onOpen} className={styles.play}>
                  <Paragraph
                    className={styles.label}
                    appearance="bold"
                    color="light"
                    uppercase
                  >
                    {buttonText}
                  </Paragraph>
                  <span className={styles.arrow}>
                    <Icon className={styles.icon} name="arrow_right" />
                  </span>
                </Action>
              ) : (
                <PageLink className={styles.play} link={link}>
                  <Paragraph
                    className={styles.label}
                    appearance="bold"
                    color="light"
                    uppercase
                  >
                    {buttonText}
                  </Paragraph>
                  <span className={styles.arrow}>
                    <Icon className={styles.icon} name="arrow_right" />
                  </span>
                </PageLink>
              )}
            </div>

            {opened && (
              <ModalWrapper onCloseModal={onClose}>
                <Form
                  item={form}
                  metaData={{ type: "course", id: course.id }}
                  instanceId={instanceId}
                  info={
                    <FormInfo
                      title={course.title}
                      date={course.timeDescription}
                    />
                  }
                  onReset={onClose}
                />
              </ModalWrapper>
            )}
          </div>
        </div>
        <ImageLite image={course.image} className={styles.image} />
      </Container>
    </div>
  );
};

export default LayoutWidget035;
